import { useSwipeable } from 'react-swipeable';
import { useNavigate } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile';
import React from 'react';

export const GlobalGestureHandler: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const handlers = useSwipeable({
    onSwipedRight: (eventData) => {
      // Only trigger if swipe starts near the left edge (for iOS-like UX)
      if (eventData.initial[0] < 40) {
        navigate(-1);
      }
    },
    trackTouch: true,
    trackMouse: false,
    preventDefaultTouchmoveEvent: false,
  });

  // Keep a stable wrapper so crossing the mobile breakpoint (e.g. on rotation)
  // does not remount AuthProvider / FacilityProvider and lose persisted state.
  return (
    <div {...(isMobile ? handlers : {})} style={{ height: "100%" }}>
      {children}
    </div>
  );
}; 